module.exports = __webpack_public_path__ + "static/media/cogito-logo_blue.59b09a86.png";